export const ITEM_TYPE_ART = 'ART';
export const ITEM_TYPE_SPR = 'SPR';
